const runningOnProd = () =>
  process.env.NODE_ENV === 'production' &&
  (window.location.origin === 'https://app.bops.ai' ||
    window.location.origin === 'https://app.gs1mex.bops.ai' ||
    window.location.origin === 'https://logyca.bops.ai' ||
    window.location.origin === 'https://app.logycaco.bops.ai');

export default runningOnProd;
